export const SmartlookEvents = {
  NAVIGATION: "Navigation",
  ONBOARDING_NAVIGATION: "Onboarding_navigation",
  PAGE_STAY_TIME: "Page_stay_time",
  NAVIGATE_TO_SWAP_PLAN: "Navigate_to_swap_plan",
  NAVIGATE_TO_BREAKFAST: "Navigate_to_breakfast",
  NAVIGATE_TO_LUNCH: "Navigate_to_lunch",
  NAVIGATE_TO_DINNER: "Navigate_to_dinner",
  NAVIGATE_TO_SNACK: "Navigate_to_snack",
  SWAP_PLAN: "Swap_plan",
  SELECT_FRUIT_OPTION: "Select_fruit_option",
  SELECT_CARB_OPTION: "Select_carb_option",
  SELECT_NUT_OPTION: "Select_nut_option",
} as const;
